import PropTypes from 'prop-types';
import React from 'react';
import ProduitsAssignes from '../mediasPages/ProduitsAssignes';
import MediaCardTemplate from './MediaCardTemplate';
import { useGetCampagneTypeProdQuery } from '../../../../redux/api/cache';

export default function ProduitAssigneGlobauxFactory(props) {
  const { data, isLoading } = useGetCampagneTypeProdQuery({ camp_seq: props.data.camp_seq, media_cd: props.media.key });

  return (
    <MediaCardTemplate isLoaded={!isLoading} card={props.card} data={data}>
      <ProduitsAssignes
        mediaKey={props.media.key}
        rowData={props.data}
        data={data}
        global={true}
      />
    </MediaCardTemplate>
  );
}

ProduitAssigneGlobauxFactory.propTypes = {
  card: PropTypes.shape({
    type_url: PropTypes.any,
  }),
  data: PropTypes.shape({
    camp_seq: PropTypes.any,
  }),
  media: PropTypes.shape({
    key: PropTypes.any,
  }),
};
